module.exports = __webpack_public_path__ + "img/cbx_bawtokens.gm.e39dfd1.png";